import { SidebarType } from '@/utils/subscription/types'

/**
 * Words people actually type, per sidebar entry. The translated label is always matched too,
 * so only list synonyms, abbreviations and the other language here.
 */
export const KEYWORDS_BY_SIDEBAR_ITEM: Partial<Record<string, string[]>> = {
  [SidebarType.Home]: ['accueil', 'home', 'tableau de bord', 'dashboard'],
  [SidebarType.Patients]: ['patient', 'patients', 'dossier', 'dossiers', 'liste', 'fiche'],
  [SidebarType.Consultations]: ['consultation', 'consult', 'teleconsultation', 'tlc', 'visite', 'historique'],
  [SidebarType.LocalConsultations]: ['consultation', 'locale', 'presentiel', 'cabinet'],
  [SidebarType.WaitingRooms]: ['salle', 'attente', 'file', 'queue', 'waiting', 'room', 'patients en attente'],
  [SidebarType.Calendar]: ['agenda', 'calendrier', 'rdv', 'rendez-vous', 'planning', 'calendar', 'appointment'],
  [SidebarType.EstablishmentAgenda]: ['agenda', 'calendrier', 'etablissement', 'planning'],
  [SidebarType.Expertises]: ['expertise', 'avis', 'teleexpertise', 'tle', 'second opinion'],
  'expertiseMeetings': ['staff', 'reunion', 'rcp', 'meeting', 'expertise'],
  [SidebarType.Emergency]: ['urgence', 'urgences', 'emergency', 'samu'],
  [SidebarType.EmergenciesMed]: ['urgence', 'urgences', 'emergency'],
  [SidebarType.MeetingLinks]: ['lien', 'liens', 'rendez-vous', 'rdv', 'commande', 'link'],
  [SidebarType.Networks]: ['reseau', 'reseaux', 'network', 'confreres'],
  [SidebarType.Staffs]: ['personnel', 'equipe', 'medecins', 'soignants', 'staff', 'collegues'],
  [SidebarType.AdminStaffs]: ['personnel', 'equipe', 'utilisateurs', 'comptes', 'users'],
  [SidebarType.ShiftMarketplace]: ['garde', 'gardes', 'creneau', 'creneaux', 'shift', 'vacation', 'remplacement'],
  [SidebarType.AdminPlannings]: ['planning', 'plannings', 'garde', 'shift', 'horaires'],
  [SidebarType.Reports]: ['rapport', 'rapports', 'compte-rendu', 'cr', 'report'],
  [SidebarType.FormTemplates]: ['formulaire', 'formulaires', 'questionnaire', 'form', 'modele'],
  [SidebarType.Chat]: ['message', 'messages', 'messagerie', 'discussion', 'chat'],
  [SidebarType.MedConnectAgent]: ['elara', 'assistant', 'ia', 'ai', 'aide', 'question'],
  [SidebarType.Tutorials]: ['tutoriel', 'tutoriels', 'video', 'videos', 'aide', 'help', 'apprendre', 'comment', 'formation'],
  [SidebarType.Onboarding]: ['demarrer', 'premiers pas', 'onboarding', 'aide'],
  [SidebarType.TimeTracking]: ['temps', 'pointage', 'heures', 'time'],
  [SidebarType.AdminStatistics]: ['stats', 'statistiques', 'chiffres', 'activite'],
  [SidebarType.AdminLicenses]: ['licence', 'licences', 'abonnement'],
  [SidebarType.AdminEstablishment]: ['etablissement', 'structure', 'centre', 'parametres'],
  [SidebarType.AdminDataExport]: ['export', 'excel', 'csv', 'donnees'],
  [SidebarType.AdminMedicalActs]: ['actes', 'facturation', 'cotation', 'billing'],
  [SidebarType.AdminDesmosActs]: ['actes', 'facturation', 'desmos'],
}

export const KEYWORDS_BY_CREATE_ACTION: Record<string, string[]> = {
  'create-patient': ['creer', 'nouveau', 'nouvelle', 'ajouter', 'patient', 'create', 'new', 'add'],
  'create-consultation': ['creer', 'nouvelle', 'nouveau', 'demarrer', 'lancer', 'consultation', 'teleconsultation', 'create', 'new', 'start'],
}

